<div *ngIf="!isLoader">
    <div class="row">
        <!-- Column -->
        <div class="col-lg-3 col-md-6">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex no-block">
                        <div class="round align-self-center round-success"><i class="fa fa-hospital-o"></i></div>
                        <div class="m-l-10 align-self-center">
                            <h3 class="m-b-0">{{hospitalCount}}</h3>
                            <h5 class="text-muted m-b-0">Hospitals</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Column -->
        <!-- Column -->
        <div class="col-lg-3 col-md-6">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex no-block">
                        <div class="round align-self-center round-info"><i class="fa fa-user-md"></i></div>
                        <div class="m-l-10 align-self-center">
                            <h3 class="m-b-0">{{doctorCount}}</h3>
                            <h5 class="text-muted m-b-0">Doctors</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Column -->
        <!-- Column -->
        <div class="col-lg-3 col-md-6">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex no-block">
                        <div class="round align-self-center round-danger"><i class="fa fa-users"></i></div>
                        <div class="m-l-10 align-self-center">
                            <h3 class="m-b-0">{{patientCount}}</h3>
                            <h5 class="text-muted m-b-0">Patients</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Column -->
        <!-- Column -->
        <div class="col-lg-3 col-md-6">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex no-block">
                        <div class="round align-self-center round-success"><i class="fa fa-question"></i></div>
                        <div class="m-l-10 align-self-center">
                            <h3 class="m-b-0">{{requestCount}}</h3>
                            <h5 class="text-muted m-b-0">Requests</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Column -->
    </div>
    <!-- Row -->
    <!-- .row -->
    <div class="row">
        <div class="col-md-4 col-sm-12 col-xs-12">
            <div *ngIf="ishosChartLoaded" class="card">
                <div class="card-body">
                    <h5 class="card-title"><small class="float-right text-success">
                            <!-- <i class="fa fa-sort-asc"></i> -->
                        </small>Hospitals</h5>

                </div>
                <div style="display: block">

                    <div id="chart-container">
                        <canvas #myCanvas id="canvas" baseChart [chartType]="chartType" [datasets]="hosChartData"
                            [labels]="chartLabels" [colors]="chartColors1" [options]="chartOptions"></canvas>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-sm-12 col-xs-12">
            <div *ngIf="isdocChartLoaded" class="card">
                <div class="card-body">
                    <h5 class="card-title"><small class="float-right text-danger">
                            <!-- <i class="fa fa-sort-desc"></i> -->
                        </small>Doctors</h5>

                </div>
                <div style="display: block">

                    <div id="chart-container">
                        <canvas #myCanvas id="canvas" baseChart [chartType]="chartType" [datasets]="docChartData"
                            [labels]="chartLabels" [colors]="chartColors" [options]="chartOptions"></canvas>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-sm-12 col-xs-12">
            <div *ngIf="isPatientChartLoaded" class="card">
                <div class="card-body">
                    <h5 class="card-title"><small class="float-right text-success">
                            <!-- <i class="fa fa-sort-asc"></i> -->
                        </small>Patients</h5>

                </div>
                <div style="display: block">

                    <div id="chart-container">
                        <canvas #myCanvas id="canvas" baseChart [chartType]="chartType" [datasets]="patientChartData"
                            [labels]="chartLabels" [colors]="chartColors2" [options]="chartOptions"></canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /.row -->
    <!--row -->
    <!-- <div class="row">
    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">Patients In</h5>
                <ul class="list-inline text-center">
                    <li>
                        <h5><i class="fa fa-circle m-r-5" style="color: #00bfc7;"></i>OPD</h5>
                    </li>
                    <li>
                        <h5><i class="fa fa-circle m-r-5" style="color: #b4becb;"></i>ICU</h5>
                    </li>
                </ul>
                
  <div>
    <div style="display: block">
      <canvas baseChart
              [datasets]="barChartData"
              [labels]="mbarChartLabels"
              [options]="barChartOptions"
              [colors]="barChartColors"
              [legend]="barChartLegend"
              [chartType]="barChartType"
              (chartHover)="chartHovered($event)"
              (chartClick)="chartClicked($event)"></canvas>
    </div>
  
  
  </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">Hospital Earning</h5>
                <ul class="list-inline text-center">
                    <li>
                        <h5><i class="fa fa-circle m-r-5" style="color: #00bfc7;"></i>OPD</h5>
                    </li>
                    <li>
                        <h5><i class="fa fa-circle m-r-5" style="color: #b4becb;"></i>ICU</h5>
                    </li>
                </ul>
  <div>
    <div style="display: block">
      <canvas baseChart
              [datasets]="barChartData"
              [labels]="mbarChartLabels"
              [options]="barChartOptions"
              [colors]="barChartColors"
              [legend]="barChartLegend"
              [chartType]="barChartType"
              (chartHover)="chartHovered($event)"
              (chartClick)="chartClicked($event)"></canvas>
    </div>
  
  
  </div>
            </div>
        </div>
    </div>
</div> -->
    <!-- row -->
    <!-- /row -->
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title m-b-0">New Hospital List</h5>
                    <p class="text-muted">Recent Hospitals added in this month</p>
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>State</th>
                                    <th>Medfest ID</th>
                                    <th>Hotline</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let h of hospitals;let i=  index" (click)="gotoHospitalProfile(h._id)">
                                    <td>{{i +1}}</td>
                                    <td>{{h.name}}</td>
                                    <td>{{h.state}}</td>
                                    <td>{{h.username}}</td>
                                    <td>{{h.phone}}</td>
                                </tr>


                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- bar graph -->
    <!-- <div class="row">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title m-b-0">Payments</h5>
                <p class="text-muted">Recent Payments in this month</p>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr role="row">
                                <th class="sorting_asc" tabindex="0" aria-controls="myTable" rowspan="1" colspan="1"
                                    aria-sort="ascending" aria-label="No: activate to sort column descending"
                                    style="width: 61px;">No</th>
                                <th class="sorting" tabindex="0" aria-controls="myTable" rowspan="1" colspan="1"
                                    aria-label="Patient: activate to sort column ascending" style="width: 202px;">
                                    Patient</th>
                                <th class="sorting" tabindex="0" aria-controls="myTable" rowspan="1" colspan="1"
                                    aria-label="Doctor: activate to sort column ascending" style="width: 166px;">Doctor
                                </th>
                                <th class="sorting" tabindex="0" aria-controls="myTable" rowspan="1" colspan="1"
                                    aria-label="Date: activate to sort column ascending" style="width: 119px;">Date</th>
                                <th class="sorting" tabindex="0" aria-controls="myTable" rowspan="1" colspan="1"
                                    aria-label="Charges: activate to sort column ascending" style="width: 130px;">
                                    Charges</th>
                                <th class="sorting" tabindex="0" aria-controls="myTable" rowspan="1" colspan="1"
                                    aria-label="Discount: activate to sort column ascending" style="width: 134px;">
                                    Discount</th>
                                <th class="sorting" tabindex="0" aria-controls="myTable" rowspan="1" colspan="1"
                                    aria-label="Total: activate to sort column ascending" style="width: 89px;">Total
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr role="row" class="odd">
                                <td class="sorting_1">1</td>
                                <td>Tiger Nixon</td>
                                <td>Steve Gection</td>
                                <td>2011/04/25</td>
                                <td>$610</td>
                                <td>15%</td>
                                <td>$320</td>
                            </tr>

                            <tr role="row" class="odd">
                                <td class="sorting_1">1</td>
                                <td>Tiger Nixon</td>
                                <td>Steve Gection</td>
                                <td>2011/04/25</td>
                                <td>$610</td>
                                <td>15%</td>
                                <td>$320</td>
                            </tr>
                            <tr role="row" class="odd">
                                <td class="sorting_1">1</td>
                                <td>Tiger Nixon</td>
                                <td>Steve Gection</td>
                                <td>2011/04/25</td>
                                <td>$610</td>
                                <td>15%</td>
                                <td>$320</td>
                            </tr>
                            <tr role="row" class="odd">
                                <td class="sorting_1">1</td>
                                <td>Tiger Nixon</td>
                                <td>Steve Gection</td>
                                <td>2011/04/25</td>
                                <td>$610</td>
                                <td>15%</td>
                                <td>$320</td>
                            </tr>
                            <tr role="row" class="odd">
                                <td class="sorting_1">1</td>
                                <td>Tiger Nixon</td>
                                <td>Steve Gection</td>
                                <td>2011/04/25</td>
                                <td>$610</td>
                                <td>15%</td>
                                <td>$320</td>
                            </tr>
                            <tr role="row" class="odd">
                                <td class="sorting_1">1</td>
                                <td>Tiger Nixon</td>
                                <td>Steve Gection</td>
                                <td>2011/04/25</td>
                                <td>$610</td>
                                <td>15%</td>
                                <td>$320</td>
                            </tr>
                            <tr role="row" class="odd">
                                <td class="sorting_1">1</td>
                                <td>Tiger Nixon</td>
                                <td>Steve Gection</td>
                                <td>2011/04/25</td>
                                <td>$610</td>
                                <td>15%</td>
                                <td>$320</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</div> -->
</div>
<loader *ngIf="isLoader"></loader>